import {FC} from 'react';

import {Text} from 'components/Text/Text';

import styles from './OrdeSuccessInfo.module.css';
import owlImage from './owl.png';

type Props = {
    orderNumber?: number;
    email: string;
    phone: string;
    paymentMethod: string;
    address: string;
};

export const OrdeSuccessInfo: FC<Props> = ({
    orderNumber,
    email,
    phone,
    paymentMethod,
    address,
}) => {
    const info = prepareInfo({
        orderNumber,
        email,
        phone,
        paymentMethod,
        address,
    });
    return (
        <div className={styles.block}>
            <img src={owlImage} className={styles.image} alt="" />
            <div className={styles.content}>
                <Text.Responsive
                    breakpointsMap={{default: 'Bold24', sm: 'Bold30'}}
                    className={styles.title}
                >
                    Спасибо за заказ!
                </Text.Responsive>
                <Text.Bold16 className={styles.warnText}>
                    Менеджер свяжется с вами в течение рабочего дня, чтобы
                    согласовать детали
                </Text.Bold16>
                <div className={styles.info}>
                    {info.map((data) => (
                        <div key={data.label} className={styles.infoRow}>
                            <Text.Regular14 className={styles.infoLabel}>
                                <span>{data.label}</span>
                            </Text.Regular14>
                            <Text.Bold14>{data.value}</Text.Bold14>
                        </div>
                    ))}
                </div>
            </div>

            <Text.Regular12 className={styles.caption}>
                Для подтверждения заказа необходимо обязательно дождаться звонка
                менеджера. Менеджер позвонит вам в течении рабочего дня. Если
                заказ был сделан в выходные или после 17:30 в рабочие дни, то мы
                свяжемся с вами на следующий рабочий день до 18:00. Подробности
                заказа отправлены на указанный вами e-mail.
            </Text.Regular12>
        </div>
    );
};

type Params = Pick<
    Props,
    'address' | 'email' | 'orderNumber' | 'paymentMethod' | 'phone'
>;
function prepareInfo({
    orderNumber,
    email,
    phone,
    paymentMethod,
    address,
}: Params) {
    const result = [];
    result.push({label: 'Номер заказа', value: orderNumber});
    result.push({label: 'E-mail', value: email});
    result.push({label: 'Телефон', value: phone});
    result.push({label: 'Способ оплаты', value: paymentMethod});
    result.push({label: 'Регион', value: address});
    return result;
}
